export function getPanelId(idPrefix: string, value: string): string | undefined {
  return `${idPrefix}-p-${value}`;
}

export function getTabId(idPrefix: string, value: string): string | undefined {
  return `${idPrefix}-t-${value}`;
}
